// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sliderrange_slider__1L8Xc {
  --rail-default-color: var(--color-lightui-accent-1);
  --rail-colored-portion: var(--color-darkui-accent-1);

  display: flex;
  align-items: center;
  position: relative;
  touch-action: none;
  margin: 7px 6px;
  user-select: none;
  cursor: pointer;
}

.sliderrange_rail__N0kQ9 {
  width: 100%;
  background: var(--rail-default-color);
  height: 6px;
  border-radius: 2px;
}

.sliderrange_rail_colored_portion__QQ5FF {
  width: auto;
  position: absolute;
  background: var(--rail-colored-portion);
}

.sliderrange_handle__MXRrZ,
.sliderrange_knob__FgF0\\+ {
  position: absolute;
  align-self: center;
  transform: translate(-50%, 0);
}

.sliderrange_knob__FgF0\\+ {
  border-radius: 50px;
  background: var(--rail-default-color);
}

.sliderrange_knob_major__BHozz {
  height: 14px;
  width: 4px;
}

.sliderrange_knob_normal__tCrlO {
  height: 12px;
  width: 4px;
}

.sliderrange_knob_minor__OuRSI {
  height: 10px;
  width: 3px;
}

.sliderrange_knob_colored__WJ6ra {
  background: var(--rail-colored-portion);
}

.sliderrange_handle__MXRrZ {
  z-index: 10;
  cursor: pointer;
  width: 12px;
  height: 12px;
  background: white;
  border: 2px solid var(--color-darkui-accent-2);
  border-radius: 12px;
  z-index: 1;
}

.sliderrange_handle_disabled__NNGbb {
  cursor: not-allowed;
  border: 2px solid var(--color-lightui-accent-2);
  z-index: 0;
}

.sliderrange_dotStart__D8h4p {
  background: var(--color-darkui-accent-3);
  display: inline-block;
  position: absolute;

  width: 6px;
  height: 6px;
  border-radius: 6px;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);

  left: 0;
}

.sliderrange_dotMid__KeIgB {
  background: var(--color-darkui-accent-3);
  display: inline-block;
  position: absolute;

  width: 6px;
  height: 6px;
  border-radius: 6px;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);

  left: 50%;
}

.sliderrange_dotEnd__PqfnA {
  background: var(--color-darkui-accent-3);
  display: inline-block;
  position: absolute;

  width: 6px;
  height: 6px;
  border-radius: 6px;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);

  left: 100%;
}

.sliderrange_tick__qaBRJ {
  background: rgba(16, 16, 16, 0.1);
  display: inline-block;
  position: absolute;

  width: 4px;
  height: 6px;
  border-radius: 6px;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
}

.sliderrange_no_shadow__CqpuS {
  box-shadow: none;
}

.sliderrange_handle__MXRrZ:not(.sliderrange_no_shadow__CqpuS):hover {
  box-shadow: 0 3px 6px rgba(16, 16, 16, 0.15), 0 3px 6px rgba(16, 16, 16, 0.35);
}

.sliderrange_no_display__Det7W {
  display: none;
}

.sliderrange_cursor_not_allowed__PqzKc {
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/SliderRange/sliderrange.module.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;EACnD,oDAAoD;;EAEpD,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8CAA8C;EAC9C,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;;EAElB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;;EAErC,OAAO;AACT;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;;EAElB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;;EAErC,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;;EAElB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;;EAErC,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;;EAElB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".slider {\n  --rail-default-color: var(--color-lightui-accent-1);\n  --rail-colored-portion: var(--color-darkui-accent-1);\n\n  display: flex;\n  align-items: center;\n  position: relative;\n  touch-action: none;\n  margin: 7px 6px;\n  user-select: none;\n  cursor: pointer;\n}\n\n.rail {\n  width: 100%;\n  background: var(--rail-default-color);\n  height: 6px;\n  border-radius: 2px;\n}\n\n.rail_colored_portion {\n  width: auto;\n  position: absolute;\n  background: var(--rail-colored-portion);\n}\n\n.handle,\n.knob {\n  position: absolute;\n  align-self: center;\n  transform: translate(-50%, 0);\n}\n\n.knob {\n  border-radius: 50px;\n  background: var(--rail-default-color);\n}\n\n.knob_major {\n  height: 14px;\n  width: 4px;\n}\n\n.knob_normal {\n  height: 12px;\n  width: 4px;\n}\n\n.knob_minor {\n  height: 10px;\n  width: 3px;\n}\n\n.knob_colored {\n  background: var(--rail-colored-portion);\n}\n\n.handle {\n  z-index: 10;\n  cursor: pointer;\n  width: 12px;\n  height: 12px;\n  background: white;\n  border: 2px solid var(--color-darkui-accent-2);\n  border-radius: 12px;\n  z-index: 1;\n}\n\n.handle_disabled {\n  cursor: not-allowed;\n  border: 2px solid var(--color-lightui-accent-2);\n  z-index: 0;\n}\n\n.dotStart {\n  background: var(--color-darkui-accent-3);\n  display: inline-block;\n  position: absolute;\n\n  width: 6px;\n  height: 6px;\n  border-radius: 6px;\n  top: 50%;\n  transform: translate3d(-50%, -50%, 0);\n\n  left: 0;\n}\n\n.dotMid {\n  background: var(--color-darkui-accent-3);\n  display: inline-block;\n  position: absolute;\n\n  width: 6px;\n  height: 6px;\n  border-radius: 6px;\n  top: 50%;\n  transform: translate3d(-50%, -50%, 0);\n\n  left: 50%;\n}\n\n.dotEnd {\n  background: var(--color-darkui-accent-3);\n  display: inline-block;\n  position: absolute;\n\n  width: 6px;\n  height: 6px;\n  border-radius: 6px;\n  top: 50%;\n  transform: translate3d(-50%, -50%, 0);\n\n  left: 100%;\n}\n\n.tick {\n  background: rgba(16, 16, 16, 0.1);\n  display: inline-block;\n  position: absolute;\n\n  width: 4px;\n  height: 6px;\n  border-radius: 6px;\n  top: 50%;\n  transform: translate3d(-50%, -50%, 0);\n}\n\n.no_shadow {\n  box-shadow: none;\n}\n\n.handle:not(.no_shadow):hover {\n  box-shadow: 0 3px 6px rgba(16, 16, 16, 0.15), 0 3px 6px rgba(16, 16, 16, 0.35);\n}\n\n.no_display {\n  display: none;\n}\n\n.cursor_not_allowed {\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slider": `sliderrange_slider__1L8Xc`,
	"rail": `sliderrange_rail__N0kQ9`,
	"rail_colored_portion": `sliderrange_rail_colored_portion__QQ5FF`,
	"handle": `sliderrange_handle__MXRrZ`,
	"knob": `sliderrange_knob__FgF0+`,
	"knob_major": `sliderrange_knob_major__BHozz`,
	"knob_normal": `sliderrange_knob_normal__tCrlO`,
	"knob_minor": `sliderrange_knob_minor__OuRSI`,
	"knob_colored": `sliderrange_knob_colored__WJ6ra`,
	"handle_disabled": `sliderrange_handle_disabled__NNGbb`,
	"dotStart": `sliderrange_dotStart__D8h4p`,
	"dotMid": `sliderrange_dotMid__KeIgB`,
	"dotEnd": `sliderrange_dotEnd__PqfnA`,
	"tick": `sliderrange_tick__qaBRJ`,
	"no_shadow": `sliderrange_no_shadow__CqpuS`,
	"no_display": `sliderrange_no_display__Det7W`,
	"cursor_not_allowed": `sliderrange_cursor_not_allowed__PqzKc`
};
export default ___CSS_LOADER_EXPORT___;
